export default {
  subTitle: 'Overview',
  pageTitle: 'Payments'
}